// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  height: 65px;
  padding: 0px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: white;
}
.header .project-logo {
  text-decoration: none;
  font-size: 1.5rem;
  color: #143B6B;
  line-height: 3em;
  padding-left: 30px;
}
.header .logo {
  margin-right: 10px !important;
}
.header .icon-logo-align {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 50%;
}
.header .icon-logo-align .MuiDivider-vertical {
  width: 2px;
  margin-left: 0px;
  background-color: rgba(0, 0, 0, 0.07);
}
.header .MuiButton-contained {
  background-color: #FFFFFF;
  padding: 0px;
  margin: 10px 20px 10px 0;
  min-width: 0;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
}
.header .MuiButton-contained:hover {
  box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.08);
  background-color: #FFFFFF;
}
.header .MuiSvgIcon-root {
  margin: 5px;
  color: #143B6B;
  font-size: 2em;
  width: 1.1em;
  height: 1.1em;
}

.header-user {
  padding: 0px 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-wrapper {
  display: flex;
  flex-direction: row;
  background: white;
  justify-content: space-between;
  border-bottom: 3px solid #143B6B;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/header.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAFF;AAIE;EACE,qBAAA;EACA,iBAAA;EACA,cAdM;EAeN,gBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;AAMI;EACE,UAAA;EACA,gBAAA;EACA,qCAAA;AAJN;AAQE;EACE,yBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EAEA,+CAAA;AANJ;AASE;EAEE,+CAAA;EACA,yBAAA;AAPJ;AAUE;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AARJ;;AAYA;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AATF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;AAVF","sourcesContent":["\r\n$primary: #143B6B;\r\n\r\n.header {\r\n  height: 65px;\r\n  padding: 0px 15px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: white;\r\n\r\n  .project-logo {\r\n    text-decoration: none;\r\n    font-size: 1.5rem;\r\n    color: $primary;\r\n    line-height: 3em;\r\n    padding-left: 30px;\r\n  }\r\n\r\n  .logo {\r\n    margin-right: 10px !important;\r\n  }\r\n\r\n  .icon-logo-align {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    max-height: 50%;\r\n\r\n    .MuiDivider-vertical {\r\n      width: 2px;\r\n      margin-left: 0px;\r\n      background-color: rgba(0, 0, 0, 0.07);\r\n    }\r\n  }\r\n  \r\n  .MuiButton-contained {\r\n    background-color: #FFFFFF;\r\n    padding: 0px;\r\n    margin: 10px 20px 10px 0;\r\n    min-width: 0;\r\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08); \r\n    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08);\r\n  }\r\n\r\n  .MuiButton-contained:hover {\r\n    -webkit-box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.08); \r\n    box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.08);\r\n    background-color: #FFFFFF;\r\n  }\r\n\r\n  .MuiSvgIcon-root {\r\n    margin: 5px;\r\n    color: #143B6B;\r\n    font-size: 2em;\r\n    width: 1.1em;\r\n    height: 1.1em;\r\n  }\r\n}\r\n\r\n.header-user {\r\n  padding: 0px 15px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n\r\n\r\n.header-wrapper {\r\n  display: flex;\r\n  flex-direction: row;\r\n  background: white;\r\n  justify-content: space-between;\r\n  border-bottom: 3px solid $primary;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
